import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { DecorType } from '../models/decor-type';

@Injectable({
  providedIn: 'root'
})
export class DecorTypeService extends BaseService<DecorType> {


  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) {
    super(http,rootUrl,'Plasard/DecorType');
   }
}
